import IAnswer from "core/interfaces/IAnswer";
import ToastProduct from "./types/ToastProduct";

export interface ToastProductsAnswer extends IAnswer {
    value: ToastProduct[];
}

const ToastProductsDefaultValue: ToastProductsAnswer = { value: [], type: 'toast-products'};

export default ToastProductsDefaultValue;